import React from 'react';
import {Box} from '@mui/material';
import {Phone} from '@mui/icons-material';
import {darkBlue} from '../theme/Theme';
import {gridCellDef} from './GridCellDef';

export const renderPhone: gridCellDef<{primaryPhone: string | null}> = (params) => {
  if (params.value) {
    return (
      <Box
        paddingLeft={1}
        paddingRight={1}
        textAlign="center"
        alignContent="center"
        justifyContent="center"
      >
        <a
          onClick={(e) => e.stopPropagation()} // disable row navigation event
          style={{
            color: darkBlue,
            display: 'flex',
            flex: 1,
            lineHeight: 1,
            alignItems: 'center',
            textDecoration: 'none',
          }}
          href={`tel:${params.value || ''}`}
        >
          <React.Fragment>
            <Phone style={{marginRight: 4}} fontSize="small" />
            {params.row.primaryPhone || ''}
          </React.Fragment>
        </a>
      </Box>
    );
  }
  return <div />;
};
